import {
  AddIcCall, AdminPanelSettings,
  Assignment,
  BarChartSharp,
  BrunchDining,
  BusinessCenter,
  Category,
  Construction,
  CorporateFare,
  Domain,
  Payments,
  SvgIconComponent,
  TrendingUp,
} from '@mui/icons-material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AddchartRoundedIcon from '@mui/icons-material/AddchartRounded';
import AirlineSeatIndividualSuiteIcon from '@mui/icons-material/AirlineSeatIndividualSuite';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CalculateIcon from '@mui/icons-material/Calculate';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
// import CreditCardIcon from '@mui/icons-material/CreditCard';
import EmailIcon from '@mui/icons-material/Email';
import EventIcon from '@mui/icons-material/Event';
import EventSeatIcon from '@mui/icons-material/EventSeat';
import ExtensionIcon from '@mui/icons-material/Extension';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ForumIcon from '@mui/icons-material/Forum';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MailIcon from '@mui/icons-material/Mail';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MessageIcon from '@mui/icons-material/Message';
import NearMeIcon from '@mui/icons-material/NearMe';
import NightShelterIcon from '@mui/icons-material/NightShelter';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PeopleIcon from '@mui/icons-material/People';
import PercentIcon from '@mui/icons-material/Percent';
import PersonIcon from '@mui/icons-material/Person';
import Person4OutlinedIcon from '@mui/icons-material/Person4Outlined';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import StorageIcon from '@mui/icons-material/Storage';
import SettingsIcon from '@mui/icons-material/Settings';
import { privileges } from '../../utils/constants/privileges';
import { routes } from '../../utils/constants/routes';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';

interface MenuItem {
  key: string;
  name?: string;
  route?: string;
  icon?: SvgIconComponent;
  privilege?: string;
  children?: MenuItem[];
  superAdminOnly?: boolean;
  /** When set, the item is shown only if token’s isEnquiriesAllowed is true. */
  requiresEnquiriesAllowed?: boolean;
  /** Shown only when organization MasterData.INTEGRATION is OPERA. */
  requiresOperaIntegration?: boolean;
}

export interface MenuSection {
  key: string;
  label: string;
  items: MenuItem[];
}

const sideMenuConfig = (strings: any): MenuSection[] => [
  {
    key: 'dashboard',
    label: '',
    items: [
      {
        key: '1',
        name: strings.menu_text_dashboard,
        route: routes.dashboard,
        icon: GridViewOutlinedIcon,
        privilege: privileges.view_booking,
      },
    ],
  },
  {
    key: 'operations',
    label: 'OPERATIONS',
    items: [
      {
        key: '4003',
        name: strings.taskList,
        route: routes.taskList,
        icon: Assignment,
      },
      {
        key: '2',
        name: strings.menu_text_bookings_diary,
        route: routes.bookings,
        icon: CalendarMonthIcon,
        privilege: privileges.view_booking,
      },
      {
        key: '1000',
        name: strings.menu_text_bookings,
        icon: FormatListBulletedIcon,
        children: [
          {
            key: '1001',
            name: strings.menu_text_bookingList,
            route: routes.bookingList,
            icon: FormatListBulletedIcon,
            privilege: privileges.view_booking_list,
          },
          {
            key: '1002',
            name: strings.menu_text_booking_event_source,
            route: routes.bookingEventSource,
            icon: FormatListBulletedIcon,
            privilege: privileges.view_booking_event_source,
          },
        ],
      },
    ],
  },
  {
    key: 'sales',
    label: 'SALES',
    items: [
      {
        key: '5',
        name: strings.menu_text_rfq,
        route: routes.rfqList,
        icon: ForumIcon,
        privilege: privileges.view_rfq,
      },
      {
        key: '3004',
        name: strings.menu_text_customers,
        route: routes.customerList,
        icon: AccountCircleIcon,
        privilege: privileges.view_customer,
      },
      {
        key: '2000',
        name: strings.menu_text_reports,
        icon: AssessmentIcon,
        children: [
          {
            key: '2001',
            name: strings.menu_text_standard_reports,
            route: routes.reports,
            icon: AddchartRoundedIcon,
            privilege: privileges.view_reports,
          },
          {
            key: '2002',
            name: strings.menu_text_consolidated_reports,
            route: routes.consolidatedReports,
            icon: BarChartSharp,
            privilege: privileges.view_consolidated_reports,
          },
        ],
      },
      {
        key: '4000',
        name: strings.crm_system,
        icon: BusinessCenter,
        children: [
          {
            key: '4001',
            name: strings.lead_management,
            route: routes.companyMasters,
            icon: Domain,
            privilege: privileges.view_company_master,
          },
          {
            key: '4002',
            name: strings.salesCalls,
            route: routes.salesManagement,
            icon: AddIcCall,
            privilege: privileges.view_sales_call,
          },
          {
            key: '4004',
            name: strings.sales_reports,
            route: routes.salesReport,
            icon: TrendingUp,
            privilege: privileges.view_sales_report,
          },
        ],
      },
    ],
  },
  {
    key: 'configuration',
    label: 'CONFIGURATION',
    items: [
      {
        key: '5000',
        name: 'Venue & Room Configs',
        icon: CorporateFareIcon,
        children: [
          {
            key: '5004',
            name: strings.menu_text_venue,
            route: routes.venue,
            icon: LocationCityIcon,
            privilege: privileges.view_venue,
          },
          {
            key: '5005',
            name: strings.menu_text_venueconfig,
            route: routes.venueConfiguration,
            icon: RoomPreferencesIcon,
            privilege: privileges.view_venue_configuration,
          },
          {
            key: '5006',
            name: strings.menu_text_room,
            route: routes.rooms,
            icon: AirlineSeatIndividualSuiteIcon,
            privilege: privileges.view_rooms,
          },
        ],
      },
      {
        key: '3',
        name: strings.menu_text_budget,
        route: routes.budgetList,
        icon: CalculateIcon,
        privilege: privileges.view_budget,
      },
    ],
  },
  {
    key: 'administration',
    label: 'ADMINISTRATION',
    items: [
      {
        key: '3000',
        name: strings.menu_text_user_management,
        icon: PersonIcon,
        children: [
          {
            key: '3002',
            name: strings.menu_text_users,
            route: routes.users,
            icon: PeopleIcon,
            privilege: privileges.view_user,
          },
          {
            key: '3003',
            name: strings.menu_text_Sources,
            route: routes.agentList,
            icon: Person4OutlinedIcon,
            privilege: privileges.view_agent,
          },
          {
            key: '3001',
            name: strings.menu_text_roles_privileges,
            route: routes.roleList,
            icon: ManageAccountsIcon,
            privilege: privileges.view_role,
          },
        ],
      },
      getMasterDataMenu(strings),
      getAdminControls(strings),
      {
        key: '4500',
        name: 'IDS Configs',
        icon: SettingsIcon,
        privilege: privileges.ids_configs,
        children: [
          {
            key: '4501',
            name: 'Event Mappings',
            route: routes.eventMappings,
            icon: EventIcon,
            privilege: privileges.ids_configs,
          },
          {
            key: '4502',
            name: 'Venue Mappings',
            route: routes.venueMappings,
            icon: LocationOnIcon,
            privilege: privileges.ids_configs,
          },
          {
            key: '4503',
            name: 'Layout Mappings',
            route: routes.layoutMappings,
            icon: EventSeatIcon,
            privilege: privileges.ids_configs,
          },
          {
            key: '4504',
            name: 'Status Mappings',
            route: routes.statusMappings,
            icon: CheckCircleIcon,
            privilege: privileges.ids_configs,
          },
          {
            key: '4505',
            name: 'IDS Logs',
            route: routes.idsLogs,
            icon: ArticleOutlinedIcon,
            privilege: privileges.ids_configs,
          },
        ],
      },
      {
        key: '4506',
        name: 'BBR ADMINS',
        icon: AdminPanelSettings,
        superAdminOnly: true,
        children: [
          {
            key: 'sa-booking-lookup',
            name: strings.menu_sa_booking_lookup,
            route: routes.saBookingLookup,
            icon: ManageSearchIcon,
            superAdminOnly: true,
          },
          {
            key: 'sa-property-onboarding',
            name: strings.menu_property_onboarding,
            route: routes.propertyOnboarding,
            icon: PlaylistAddCheckIcon,
            superAdminOnly: true,
          },
          {
            key: 'sa-property-readiness',
            name: strings.menu_property_readiness,
            route: routes.propertyReadinessDashboard,
            icon: FactCheckIcon,
            superAdminOnly: true,
          },
          {
            key: 'sa-opera-logs',
            name: strings.menu_opera_logs,
            route: routes.operaLogs,
            icon: ArticleOutlinedIcon,
            superAdminOnly: true,
            requiresOperaIntegration: true,
          },
        ],
      },
    ],
  },
];

const getMasterDataMenu = (strings: any) => {
  return {
    key: '6000',
    name: strings.menu_text_master_data,
    icon: StorageIcon,
    children: [
      {
        key: '6002',
        name: strings.menu_text_segment,
        route: routes.eventType,
        icon: EventIcon,
        privilege: privileges.view_event_type,
      },
      {
        key: '6009',
        name: strings.menu_text_venueType,
        route: routes.venueType,
        icon: NearMeIcon,
        privilege: privileges.view_venue_type,
      },
      { key: 'divider' },
      {
        key: '6005',
        name: strings.menu_text_pricePackage,
        route: routes.pricePackage,
        icon: LocalOfferIcon,
        privilege: privileges.view_price_package,
      },
      {
        key: '6004',
        name: strings.menu_text_layout,
        route: routes.layout,
        icon: EventSeatIcon,
        privilege: privileges.view_layout,
      },
      {
        key: '6001',
        name: strings.menu_title_addOns,
        route: routes.addOns,
        icon: ExtensionIcon,
        privilege: privileges.view_addOn,
      },
      { key: 'divider' },
      {
        key: '6006',
        name: strings.menu_text_roomType,
        route: routes.roomType,
        icon: NightShelterIcon,
        privilege: privileges.view_room_type,
      },
      {
        key: '6007',
        name: strings.menu_text_meal_plan,
        route: routes.mealPlans,
        icon: BrunchDining,
        privilege: privileges.view_meal_plan,
      },
      { key: 'divider' },
      {
        key: '6003',
        name: strings.menu_title_location,
        route: routes.location,
        icon: LocationOnIcon,
        privilege: privileges.view_location,
      },
      {
        key: '6019',
        name: strings.menu_text_taxGroup,
        route: routes.taxGroup,
        icon: AttachMoneyIcon,
        privilege: privileges.view_tax_code,
      },
      {
        key: '6011',
        name: strings.menu_text_taxCode,
        route: routes.taxCode,
        icon: AttachMoneyIcon,
        privilege: privileges.view_tax_code,
      },
      {
        key: '6010',
        name: strings.menu_text_surcharge,
        route: routes.surcharge,
        icon: PercentIcon,
        privilege: privileges.view_surcharge,
      },
      {
        key: '6018',
        name: strings.menus_text_industry_type,
        route: routes.industryType,
        icon: CorporateFare,
        privilege: privileges.view_industry_type,
      },
      {
        key: '6014',
        name: strings.menu_text_address,
        route: routes.address,
        icon: LocationOnIcon,
        privilege: privileges.view_address,
      },
    ],
  };
};

const getAdminControls = (strings: any) => {
  return {
    key: '7000',
    name: strings.menu_text_admin_controls,
    icon: Construction,
    children: [
      {
        key: '5001',
        name: strings.menu_text_parentOrg,
        route: routes.parentOrganization,
        icon: NearMeIcon,
        privilege: privileges.view_parent_organization,
      },
      {
        key: '5002',
        name: strings.menu_text_organization,
        route: routes.organization,
        icon: HomeWorkIcon,
        privilege: privileges.view_org,
      },
      { key: 'divider' },
      {
        key: '7002',
        name: strings.menu_text_mailTemplate,
        route: routes.mailTemplate,
        icon: MailIcon,
        privilege: privileges.view_mail_template,
      },
      {
        key: '7003',
        name: strings.menu_text_email_event_config,
        route: routes.emailEventConfig,
        icon: EmailIcon,
        privilege: privileges.view_email_event_config,
      },
      {
        key: '7001',
        name: strings.menu_text_templateSchedule,
        route: routes.templateSchedule,
        icon: PendingActionsIcon,
        privilege: privileges.view_template_schedule,
      },
      {
        key: '6015',
        name: strings.menu_title_booking_msg,
        route: routes.bookingMessage,
        icon: LibraryBooksIcon,
        privilege: privileges.view_booking_message,
      },
      {
        key: '6017',
        name: strings.menu_text_systemMessage,
        route: routes.systemMessage,
        icon: MessageIcon,
        privilege: privileges.view_system_message,
      },
      { key: 'divider' },
      {
        key: '6013',
        name: strings.menu_text_addOnCategories,
        route: routes.addOnCategoriesList,
        icon: Category,
        privilege: privileges.view_add_on_categories,
      },
      {
        key: '6020',
        name: strings.menu_text_part_of_day,
        route: routes.partOfDay,
        icon: WbTwilightIcon,
        privilege: privileges.view_part_of_day,
      },
      {
        key: '6021',
        name: strings.menu_text_payment_methods,
        route: routes.paymentMethods,
        icon: Payments,
        privilege: privileges.view_payment_methods,
      },
      {
        key: '5007',
        name: strings.menu_text_payment_config,
        route: routes.paymentConfig,
        icon: AccountBalanceWalletIcon,
        privilege: privileges.view_payment_config,
      },
    ],
  };
};

export default sideMenuConfig;
